export default {
  'phone': 'Телефон',
  'description': 'Комментарий к объявлению',
  'phone_id': 'Номер'
}
